import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponseUser } from 'entities/Users/api/types'

export class MemberRow extends RowBase<IResponseUser> {
  constructor(origin: IResponseUser) {
    super(origin)
    makeObservableRowBase(this)
  }

  get id() {
    return this.origin.id
  }

  get fullName() {
    return (
      this.origin.full_name ||
      `${this.origin.first_name ?? ''} ${this.origin.last_name ?? ''}`.trim() ||
      '—'
    )
  }

  get email() {
    return this.origin.email ?? '—'
  }
}
